// @ts-check
/**
 * Stránkovaný seznam bez obnovení stránky (R-15 sekce 2, FR-2-38 až FR-2-41; R-22 změna S4:
 * jeden modul pro každý seznam s patičkou a volitelnými filtry — výpis `/procedures`
 * i úvod `/`).
 *
 * Kořen: `[data-module="list"]` s trvalou živou oblastí `[data-count]` (`aria-live`,
 * `tabindex="-1"`) a seznamem `[data-list]` s tabulkou (`tbody` řádků) a patičkou
 * `[data-pagination]`: odkaz „Od začátku" `a[data-page]` a „Zobrazit dalších N" `a[data-more]`
 * (R-11 změna 18. 10. 2026) — obě oblasti jsou POVINNÉ (bez nich `init` tiše skončí);
 * formulář `form[data-filters]` (`method="get"`, selecty, zaškrtávátka) je VOLITELNÝ (výpis,
 * úvod a místa ho mají od sekce 13 R-5; jiný formulář modul nepřebírá, FR-13-35).
 * Bez JS odešle formulář celou stránku a odkazy patičky navigují — stav je vždy v URL
 * (`?page=N` = řádky strany N).
 *
 * S JS: `change` selectu formuláře → URL z `FormData` + `action`; levý klik bez
 * modifikátorů na `a[data-page]` → `href` odkazu. Obojí načte fragment (`lib/fragment.js`,
 * předchozí požadavek zrušen `AbortController`) a vymění obsah oblastí, které kořen MĚL při
 * `init` (`[data-filters]`, `[data-count]`, `[data-tab-count]` = čip počtu v záložkách,
 * `[data-save-search]` = obal odkazu „Uložit hledání“, `[data-list]`; fragment musí nést právě je, jinak se nic nemění a stránka přejde celá). Formulář se vyměňuje proto, že server
 * nad `status=all` volbu „Nejbližší lhůta" nekreslí a `sort=deadline` převede na `newest` —
 * select nesmí lhát o řazení. Výměna ZAPÍŠE DO HISTORIE `history.pushState` s cestou a dotazem
 * z hlavičky `Link rel="canonical"` — jen liší-li se od současné adresy (`location.pathname
 * + search`), aby dvojí volba téže stránky nedala dva záznamy (R-15 změna 18. 10. 2026,
 * FR-2-66). Zpět a Vpřed (`popstate` na `window`) načtou fragment adresy z historie a vymění
 * tytéž oblasti BEZ zápisu (FR-2-67) — jako bez JS, kde je každé odeslání formuláře nová
 * stránka. `popstate` s adresou shodnou se zobrazeným seznamem (`shown`) a bez běžícího načtení
 * nic nenačte — tak přichází i navigace na kotvu (skip link `#main`, FR-2-74).
 *
 * Titulek okna (R-23, FR-2-97): po každé úspěšné změně obsahu (výměna, připojení, `popstate`)
 * modul přiřadí `document.title` text `<title>` fragmentu (`fetchFragment().title`), je-li
 * neprázdný — titulek skládá jen server, modul žádný text neskládá.
 *
 * Připojení další strany (R-15 změna S3, FR-2-81, FR-2-82): levý klik na `a[data-more]` načte
 * fragment jeho `href` týmž `AbortController` (druhý klik během načítání ruší první), PŘIPOJÍ
 * řádky `[data-list] tbody` fragmentu za stávající (`append`) a vymění jen `[data-pagination]`
 * (`[data-filters]` a `[data-count]` zůstávají — stejný filtr, stejný počet; živá oblast by týž
 * počet ohlásila znovu); adresu zapíše do historie jako výměnu. Chybí-li ve fragmentu `tbody`
 * (prázdný stav) nebo `[data-pagination]`, nic se nemění a stránka přejde na adresu celá.
 * Zpět po připojení ukáže jen stranu N−1 (adresa = strana, shodně s obnovením a bez JS).
 *
 * Fokus (FR-2-73): po změně filtru na prvek se stejným `name` v novém formuláři, po „Od začátku"
 * na `[data-count]` (posune kontejner na začátek seznamu a čtečka ohlásí počet), po připojení na
 * první `a[href]` prvního připojeného řádku (odkaz titulku; bez řádku na `[data-count]`); jinak
 * (Zpět) odpojí-li výměna prvek s fokusem, jde fokus na ovládací prvek téhož jména ve formuláři,
 * a není-li (ani formulář), na `[data-count]` — fokus nikdy nespadne na `body`. Selhání (síť, stav ≠ 200, jiný
 * Content-Type, výjimka výměny) → `location.assign(url)` celou stránkou, nikdy prázdný seznam;
 * zrušený požadavek selhání není.
 *
 * Klik na řádek (R-13 sekce 3, FR-3-13): prostý levý klik (bez modifikátorů, bez
 * `defaultPrevented`) kamkoli do `tr[data-href]` mimo `a, button, input, select, textarea, label`
 * a bez rozbaleného výběru textu (`getSelection().isCollapsed`) naviguje celou stránkou na
 * `data-href` (`navigate`). Modifikátory se ignorují záměrně — nové okno dává jen odkaz Detail
 * a název; řádek nemá `tabindex` (klávesnice jde přes odkazy). Týž delegovaný posluchač platí pro
 * řádky připojené „Zobrazit dalších" i pro úvod.
 *
 * Seznam zadavatelů `/buyers` (sekce 3 R-25 c–f, B1b upřesnění 17, 18): týž modul, formulář
 * [data-filters] s tlačítky typu `button[type=submit][name=type]` (aria-pressed), polem
 * hledání `[name=q]` a selectem kraje. `submit` formuláře (tlačítko typu, Enter) → `preventDefault`,
 * URL z `FormData` + jméno a hodnota `event.submitter` (první submit tlačítko formuláře = výchozí
 * tlačítko nese aktuální typ, takže Enter v hledání typ zachová) → výměna oblastí; fokus po volbě
 * typu na `[name=type][aria-pressed=true]` (namedItem dává RadioNodeList). `input` v `[name=q]`
 * → ustálení `lib/settle.js` (300 ms; `deps.timers` v testech) → `requestSubmit(výchozí
 * tlačítko)` → načtení BEZ výměny `[data-filters]` (pole nesmí ztratit znaky napsané během
 * požadavku) a bez přesunu fokusu; každá JINÁ cesta načtení (tlačítko typu, select, odkaz
 * stránkování, Zpět) čekající ustálení zruší, aby jeho pozdní odeslání starým výchozím
 * tlačítkem nepřepsalo její požadavek. Patička `[data-pagination]` stojící MIMO `[data-list]`
 * (v panelu vedle živé oblasti) se vyměňuje jako oblast; `[data-count]` je u obou stránek jediná
 * živá oblast — mění se jen její TEXT a jen liší-li se od fragmentu (i po „Zobrazit další", kde
 * seznam zadavatelů ukazuje „Zobrazeno N z M").
 *
 * Výpis `/procedures` (sekce 3 R-29 c, FR-3-46): totéž pole `[name=q]` ve `[data-filters]` se
 * ustálí a odešle se všemi filtry formuláře; druhé pole q v liště kostry stojí MIMO kořen
 * (GET `/procedures` celou stránkou) a modul ho nevidí.
 *
 * Panel Obory (sekce 13 R-8, FR-13-30 až FR-13-33): ovládací prvek patří formuláři podle
 * `el.form === form` — čipy `name="sector"` a kódy stromu `name="cpv"` stojí MIMO `<form>`
 * s atributem `form="list-filter"` (`FormData` je sbírá). `change` zaškrtávátka → ustálení
 * `lib/settle.js` (300 ms, instance vedle hledání; tři změny = jeden požadavek) → fragment adresy
 * z `FormData`, výměna oblastí včetně `[data-sectors]`, `[data-sector-summary]` a `[data-heading]`
 * (kořen bez nich — stránka zadavatele — je neřeší), historie a fokus na prvek téhož jména
 * A HODNOTY (i po Zpět, když výměna čip odpojila); s fokusem v poli q formuláře bez výměny
 * formuláře a fokusu (rozepsané znaky). Obě ustálení ruší společně každá jiná cesta načtení
 * (`cancelPending`) kromě „Zobrazit dalších“, která ruší jen hledání. Strom „Všechny obory a kódy“ řídí `lib/sector-tree.js`; po každé
 * úspěšné výměně (i Zpět) modul volá jeho `sync(url)` — zaškrtnutí kódů podle adresy a jediný
 * nositel kódu: skrytá `cpv` formuláře kódů se zaškrtávátkem ve stromu se odstraní.
 *
 * Posluchače jsou delegované na kořeni (přežijí výměnu) a na `window` (popstate), všechny
 * s volitelným `signal` kořene; časovače jsou jen sdílená ustálení, žádné texty UI (počet
 * i text tlačítka nese fragment), nic mimo `root`. Závislosti `fetch`, `navigate`, `pushState`,
 * `signal`, `timers` jdou vstříknout (jsdom testy), výchozí z okna dokumentu.
 */

import { plainClick } from './lib/click.js';
import { fetchFragment, swap, append } from './lib/fragment.js';
import { initSectorTree } from './lib/sector-tree.js';
import { settle } from './lib/settle.js';

/**
 * Možné oblasti výměny (patička výpisu je uvnitř `[data-list]`); kořen má podmnožinu.
 * `[data-tab-count]` je čip počtu v záložkách (list-tabs, V1a sekce 3) — volitelný jako formulář,
 * aby po změně filtru nestárl; fragment ho musí nést, když ho kořen měl při startu. Panel Obory
 * (sekce 13 R-8): čipy `[data-sectors]` a patička `[data-sector-summary]`; `[data-heading]` je
 * nadpis seznamu úvodu podle výběru (R-5). Slot stromu `[data-sector-tree]` se nevyměňuje.
 * `[data-save-search]` je obal odkazu „Uložit hledání“ (sekce 7 R-7, nález C1 brány): cíl nese
 * kanonický dotaz filtru, proto se mění s výpisem; dialog otevře delegovaný posluchač `app.js`.
 */
const AREAS = [
  '[data-filters]',
  '[data-count]',
  '[data-tab-count]',
  '[data-save-search]',
  '[data-list]',
  '[data-sectors]',
  '[data-sector-summary]',
  '[data-heading]',
];
/** Oblasti, bez kterých modul nestartuje (R-22). */
const REQUIRED = ['[data-count]', '[data-list]'];
/** Živá oblast počtu — mění se jen její text (jediná živá oblast seznamu). */
const COUNT = '[data-count]';
/** Formulář filtrů. */
const FILTERS = '[data-filters]';
/** Pole hledání s ustálením (B1b; F2). */
const QUERY = 'input[name="q"]';
/** Ustálení hledání v ms (ui-checklist bod 14). */
const SETTLE_MS = 300;
/** Řádky tabulky — při připojení další strany se rozšiřují. */
const ROWS = '[data-list] tbody';
/** Patička bloku — při připojení se vyměňuje (obal existuje i na poslední straně). */
const PAGINATION = '[data-pagination]';
/** Klikací řádek (R-13 sekce 3). */
const ROW = 'tr[data-href]';
/** Ovládací prvky uvnitř řádku, jejichž klik řádku nepatří. */
const ROW_CONTROLS = 'a, button, input, select, textarea, label';

/**
 * @typedef {object} Deps
 * @property {import('./lib/fragment.js').Fetcher} [fetch]
 * @property {(url: string) => void} [navigate] přechod celou stránkou (výchozí `location.assign`)
 * @property {(url: string) => void} [pushState] zápis URL do historie (výchozí `history.pushState`)
 * @property {AbortSignal} [signal] zrušení všech posluchačů modulu (kořen i `popstate` na window)
 * @property {import('./lib/settle.js').Timers} [timers] časovače ustálení hledání, zaškrtávátek
 *   a hledání ve stromu (testy)
 */

/**
 * URL z hodnot formuláře: `action` + dotaz z `FormData` (jen neprázdné řetězce — pole bez
 * výběru do adresy nepatří, OP 0.3.5 R-10; výchozí hodnoty zůstávají, kanonický tvar zná server;
 * `page` formulář nenese) + jméno a hodnota odesílajícího tlačítka (`submitter`; tlačítko bez
 * jména nebo s prázdnou hodnotou — „Všichni" na /buyers — nic nepřidá).
 * @param {HTMLFormElement} form
 * @param {Window & typeof globalThis} win
 * @param {Element | null} [submitter]
 */
function formUrl(form, win, submitter = null) {
  const params = new win.URLSearchParams();
  for (const [name, value] of new win.FormData(form)) {
    if (typeof value === 'string' && value !== '') params.append(name, value);
  }
  if (
    submitter instanceof win.HTMLButtonElement &&
    submitter.name !== '' &&
    submitter.value !== ''
  ) {
    params.append(submitter.name, submitter.value);
  }
  const action = form.getAttribute('action') || win.location.pathname;
  const query = params.toString();
  return query === '' ? action : `${action}?${query}`;
}

/**
 * Inicializace modulu nad kořenem `[data-module="list"]`.
 * @param {HTMLElement} root
 * @param {Deps} [deps]
 */
export default function init(root, deps = {}) {
  const doc = root.ownerDocument;
  const win = /** @type {Window & typeof globalThis} */ (doc.defaultView ?? globalThis);
  if (REQUIRED.some((selector) => root.querySelector(selector) === null)) return;
  /** Volitelný formulář filtrů (výpis, úvod, místa, zadavatelé). */
  const form = /** @type {HTMLFormElement | null} */ (root.querySelector('form' + FILTERS));
  /**
   * Výchozí tlačítko formuláře (první submit v pořadí stromu, jako implicitní odeslání
   * prohlížeče): u seznamu zadavatelů nese aktuální typ, u výpisu je beze jména. Hledá se
   * pokaždé znovu — výměna `[data-filters]` děti formuláře nahradí a tlačítko z doby startu
   * by bylo odpojené (`requestSubmit` na něj v prohlížeči vyhodí NotFoundError).
   */
  const defaultButton = () =>
    /** @type {HTMLButtonElement | null} */ (
      form?.querySelector('button[type="submit"], input[type="submit"]') ?? null
    );
  /**
   * Oblasti výměny = ty z AREAS, které kořen má při startu, + patička stojící mimo
   * `[data-list]` (seznam zadavatelů); fragment musí nést právě je.
   */
  const areas = AREAS.filter((selector) => root.querySelector(selector) !== null);
  if (
    root.querySelector(PAGINATION) !== null &&
    root.querySelector(`[data-list] ${PAGINATION}`) === null
  ) {
    areas.push(PAGINATION);
  }

  const doFetch = deps.fetch ?? /** @type {import('./lib/fragment.js').Fetcher} */ (win.fetch);
  const navigate = deps.navigate ?? ((url) => win.location.assign(url));
  const pushState = deps.pushState ?? ((url) => win.history.pushState(null, '', url));
  const listen = { signal: deps.signal };
  const here = () => win.location.pathname + win.location.search;
  /** Prvek patří formuláři filtrů — i form-associated mimo `<form>` (čipy oborů, kódy stromu). */
  const inForm = (/** @type {unknown} */ el) =>
    form !== null && typeof el === 'object' && el !== null && 'form' in el && el.form === form;
  /** Strom oborů a kódů v panelu (R-8); bez slotu je `sync` bez účinku. */
  const tree = initSectorTree(root, {
    fetch: doFetch,
    navigate,
    timers: deps.timers,
    signal: deps.signal,
    here,
  });

  /** Rozpracovaný požadavek; další ho zruší (FR-2-41). @type {AbortController | null} */
  let inflight = null;
  /** Adresa (cesta + dotaz) právě zobrazeného výpisu (FR-2-74). */
  let shown = here();
  /** Příští `submit` přišel z ustálení hledání: bez výměny formuláře a bez přesunu fokusu. */
  let quiet = false;
  /**
   * Zrušení čekajících ustálení hledání i zaškrtávátek (upřesnění 4 karty B2). Volá ho KAŽDÁ
   * jiná cesta načtení (tlačítko typu, select, odkaz stránkování, Zpět, vypršení druhého
   * ustálení): jinak by ustálení vypršelo během jejího požadavku, odeslalo formulář STARÝM
   * výchozím tlačítkem a požadavek tiše zrušilo — volba typu nebo adresa z historie by zmizela.
   * Bez formuláře není co rušit.
   */
  let cancelPending = () => {};
  /**
   * Jen ustálení hledání — „Zobrazit dalších“ (vada 2 revize B2): čekající změna zaškrtávátka
   * má doběhnout (její načtení zruší rozpracované připojení), jinak by čip lhal o adrese.
   */
  let cancelSearch = () => {};

  /**
   * Fokus na ovládací prvek formuláře daného jména; `false`, když takový (ani formulář) není.
   * Víc prvků téhož jména = tlačítko typu s `aria-pressed="true"`, jinak prvek s hodnotou
   * `value` (čip oboru, kód stromu), jinak první.
   */
  function focusControl(/** @type {string} */ name, /** @type {string | undefined} */ value) {
    let control = form?.elements.namedItem(name) ?? null;
    if (control instanceof win.RadioNodeList) {
      const items = /** @type {HTMLInputElement[]} */ (Array.from(control));
      control =
        items.find((el) => el.getAttribute('aria-pressed') === 'true') ??
        items.find((el) => value !== undefined && el.value === value) ??
        items[0] ??
        null;
    }
    if (!(control instanceof win.HTMLElement)) return false;
    control.focus();
    return true;
  }

  function focusCount() {
    /** @type {HTMLElement | null} */ (root.querySelector(COUNT))?.focus();
  }

  /**
   * Výměna jedné oblasti: živá oblast počtu dostane jen nový TEXT a jen liší-li se (čtečka
   * neohlásí týž počet znovu), ostatní oblasti výměnou dětí (`swap`).
   * @param {Document} doc
   * @param {string} selector
   */
  function swapArea(doc, selector) {
    if (selector !== COUNT) {
      swap(root, doc, selector);
      return;
    }
    const target = root.querySelector(COUNT);
    const source = doc.querySelector(COUNT);
    if (target === null || source === null) throw new Error(`chybí ${COUNT}`);
    if (target.textContent !== source.textContent) target.textContent = source.textContent;
  }

  /**
   * Načte fragment adresy `url`; předchozí požadavek zruší. `null` = zrušeno (jiný požadavek
   * ho předběhl, nic se neděje) nebo selhání (už navigovalo celou stránkou).
   * @param {string} url cesta a dotaz fragmentu
   * @param {string[]} required selektory, které fragment musí mít, jinak navigace (atomicky)
   * @returns {Promise<{ doc: Document, url: string, title: string } | null>}
   */
  async function request(url, required) {
    inflight?.abort();
    const ctrl = new win.AbortController();
    inflight = ctrl;
    /** @type {{ doc: Document, url: string, title: string }} */
    let result;
    try {
      result = await fetchFragment(url, {
        signal: ctrl.signal,
        fetch: doFetch,
        base: win.location.href,
      });
    } catch {
      if (!ctrl.signal.aborted) navigate(url);
      return null;
    }
    if (ctrl.signal.aborted) return null;
    // Atomicky: chybí-li ve fragmentu kterákoli oblast, nic se nepřepíše (diagram R-15).
    if (required.some((selector) => result.doc.querySelector(selector) === null)) {
      navigate(url);
      return null;
    }
    return result;
  }

  /**
   * Po úspěšné změně DOM: nový záznam historie jen pro novou adresu (stejná kanonická adresa
   * = dvojí Zpět na tutéž stránku), zapamatování zobrazené adresy (FR-2-74) a titulek okna
   * z fragmentu, je-li neprázdný (FR-2-97).
   * @param {string} url kanonická adresa fragmentu
   * @param {boolean} record zapsat do historie (ne při `popstate`)
   * @param {string} title text `<title>` fragmentu (`""` = beze změny)
   */
  function settled(url, record, title) {
    inflight = null;
    if (record && url !== here()) pushState(url);
    shown = here();
    if (title !== '') doc.title = title;
  }

  /**
   * @param {string} url cesta a dotaz fragmentu
   * @param {{ focusName?: string, focusValue?: string, focusCount?: boolean, yieldToQuery?: boolean }} after
   *   kam s fokusem po výměně (`focusValue` = hodnota mezi prvky téhož jména — čip, kód;
   *   `yieldToQuery` = načtení z ustálení zaškrtávátka ustoupí psaní do pole hledání)
   * @param {boolean} record zapsat kanonickou adresu do historie (ne při `popstate`)
   * @param {boolean} [keepFilters] nevyměňovat `[data-filters]` (ustálené hledání); fokus se
   *   přesune jen z odpojeného prvku
   */
  async function load(url, after, record, keepFilters = false) {
    const result = await request(url, areas);
    if (result === null) return;
    // Prvek s fokusem před výměnou, jeho jméno a hodnota, patří-li formuláři (FR-2-73).
    const active = doc.activeElement;
    const activeName = active !== null && inForm(active) ? active.getAttribute('name') : null;
    const activeValue = active instanceof win.HTMLInputElement ? active.value : undefined;
    // Píše-li uživatel V OKAMŽIKU ODPOVĚDI do pole hledání formuláře, formulář se nevyměňuje
    // a fokus zůstává (rozepsané znaky; vady 3 revize a 2 opravného kola B2).
    // Jen u ustálení zaškrtávátka — Enter v poli hledání formulář vymění a fokus vrátí do pole.
    const typing =
      after.yieldToQuery === true &&
      active instanceof win.HTMLInputElement &&
      active.matches(QUERY) &&
      inForm(active);
    const keep = keepFilters || typing;
    const focusAfter = typing ? {} : after;
    try {
      for (const selector of areas) {
        if (keep && selector === FILTERS) continue;
        swapArea(result.doc, selector);
      }
    } catch {
      navigate(url);
      return;
    }
    // Kódy stromu podle adresy, jediný nositel kódu (upřesnění 2) a odkaz stromu z fragmentu
    // (stojí mimo oblasti; změna místa strom sbalí) — PŘED fokusem.
    tree.sync(result.url, result.doc);
    settled(result.url, record, result.title);
    // Bez výměny formuláře (keep) je focusAfter prázdné: platí jen záchrana fokusu odpojeného
    // prvku (čip vyměněný s [data-sectors]; vada 3 opravného kola B2, FR-2-73).
    if (focusAfter.focusName !== undefined) {
      focusControl(focusAfter.focusName, focusAfter.focusValue);
    } else if (focusAfter.focusCount) {
      focusCount();
    } else if (active !== null && !active.isConnected) {
      if (activeName === null || !focusControl(activeName, activeValue)) focusCount();
    }
  }

  /**
   * Připojení další strany (FR-2-81): řádky za stávající, patička z fragmentu (a text živé
   * oblasti, liší-li se — „Zobrazeno N z M" seznamu zadavatelů), fokus na odkaz prvního
   * připojeného řádku. Fragment bez tbody nebo patičky = celá stránka (FR-2-82).
   * @param {string} url href odkazu „Zobrazit dalších"
   */
  async function more(url) {
    const result = await request(url, [ROWS, PAGINATION]);
    if (result === null) return;
    /** @type {Element[]} */
    let added;
    try {
      added = append(root, result.doc, ROWS);
      swap(root, result.doc, PAGINATION);
      // Patička mimo [data-list] = seznam zadavatelů: „Zobrazeno N z M" po připojení roste;
      // výpis (patička uvnitř) drží týž počet a živá oblast ho neohlásí znovu.
      if (areas.includes(PAGINATION)) swapArea(result.doc, COUNT);
    } catch {
      navigate(url);
      return;
    }
    settled(result.url, true, result.title);
    const first = added[0]?.querySelector('a[href]');
    if (first instanceof win.HTMLElement) {
      first.focus();
    } else {
      focusCount();
    }
  }

  if (form !== null) {
    root.addEventListener(
      'change',
      (event) => {
        const target = event.target;
        if (!inForm(target)) return;
        if (target instanceof win.HTMLSelectElement) {
          cancelPending();
          // Výchozí tlačítko doplní, co formulář nese jen v tlačítkách (typ zadavatele).
          void load(formUrl(form, win, defaultButton()), { focusName: target.name }, true);
        } else if (target instanceof win.HTMLInputElement && target.type === 'checkbox') {
          // Letící požadavek nese starší výběr: jeho pozdní výměna by tento klik odškrtla
          // a ustálení by poslalo znovu jeho adresu (vada 1 opravného kola B2).
          inflight?.abort();
          inflight = null;
          pick(target.name, target.value);
        }
      },
      listen,
    );
    // Odeslání formuláře (tlačítko typu, Enter v hledání, ustálené hledání): URL s hodnotou
    // odesílajícího tlačítka; fokus po tlačítku s jménem na něj (aria-pressed), po Enter zůstane
    // na poli téhož jména, po ustáleném hledání se formulář nevyměňuje a fokus nemění.
    root.addEventListener(
      'submit',
      (event) => {
        if (event.target !== form) return;
        event.preventDefault();
        // Odeslání z ustálení už časovač spotřebovalo — zrušení je pak bez účinku.
        cancelPending();
        const submitter =
          event instanceof win.SubmitEvent && event.submitter instanceof win.Element
            ? event.submitter
            : null;
        const keepFilters = quiet;
        const url = formUrl(form, win, submitter);
        if (keepFilters) {
          void load(url, {}, true, true);
          return;
        }
        const active = doc.activeElement;
        const name =
          submitter !== null && submitter !== defaultButton()
            ? submitter.getAttribute('name')
            : active !== null && inForm(active)
              ? active.getAttribute('name')
              : null;
        void load(url, name === null ? {} : { focusName: name }, true);
      },
      listen,
    );
    // Hledání: ustálení 300 ms, pak odeslání výchozím tlačítkem (zachová typ) bez výměny pole.
    // Příznak platí jen po dobu synchronního `requestSubmit`: nevyvolá-li submit (výjimka,
    // neplatný formulář), nesmí zůstat viset na příští volbu typu.
    const search = settle(
      () => {
        quiet = true;
        try {
          form.requestSubmit(defaultButton() ?? undefined);
        } finally {
          quiet = false;
        }
      },
      SETTLE_MS,
      deps.timers ?? {},
    );
    // Zaškrtávátko (čip oboru, kód stromu; R-8): ustálení 300 ms vlastní instancí, pak fragment
    // adresy z FormData a fokus na prvek téhož jména a hodnoty (FR-13-30, FR-13-31).
    const pick = settle(
      (/** @type {string} */ name, /** @type {string} */ value) => {
        cancelPending();
        // Fokus v poli hledání v okamžiku odpovědi rozhoduje load (bez výměny formuláře).
        void load(
          formUrl(form, win, defaultButton()),
          { focusName: name, focusValue: value, yieldToQuery: true },
          true,
        );
      },
      SETTLE_MS,
      deps.timers ?? {},
    );
    cancelSearch = search.cancel;
    cancelPending = () => {
      search.cancel();
      pick.cancel();
    };
    deps.signal?.addEventListener('abort', () => cancelPending());
    root.addEventListener(
      'input',
      (event) => {
        const target = event.target;
        if (!(target instanceof win.HTMLInputElement) || !target.matches(QUERY)) return;
        if (!inForm(target)) return;
        search();
      },
      listen,
    );
  }

  root.addEventListener(
    'click',
    (event) => {
      if (!(event instanceof win.MouseEvent) || !plainClick(event)) return;
      const target = event.target;
      if (!(target instanceof win.Element)) return;
      const link = target.closest('a[data-more][href], a[data-page][href]');
      if (link !== null && root.contains(link)) {
        const href = link.getAttribute('href');
        if (href === null) return;
        event.preventDefault();
        if (link.hasAttribute('data-more')) {
          cancelSearch();
          void more(href);
        } else {
          cancelPending();
          void load(href, { focusCount: true }, true);
        }
        return;
      }
      // Klik na řádek mimo ovládací prvky a mimo výběr textu (FR-3-13).
      const row = target.closest(ROW);
      if (!(row instanceof win.HTMLElement) || !root.contains(row)) return;
      if (target.closest(ROW_CONTROLS) !== null) return;
      const selection = win.getSelection();
      if (selection !== null && !selection.isCollapsed) return;
      const href = row.dataset.href;
      if (href) navigate(href);
    },
    listen,
  );

  // Zpět / Vpřed: adresa už je z historie, seznam se jí přizpůsobí bez zápisu. Kotva (#main)
  // vyšle popstate s touž adresou — bez běžícího načtení není co měnit (FR-2-74).
  win.addEventListener(
    'popstate',
    () => {
      const url = here();
      if (url === shown && inflight === null) return;
      cancelPending();
      void load(url, {}, false);
    },
    listen,
  );
}
